import Link from 'next/link'
import clsx from 'clsx'

import { Button } from '@wartek-id/button-v1'
import { Text } from '@wartek-id/text-v1'
import { Card } from '@wartek-id/card'

import { PENGELOLAAN_KINERJA_PS_PATH } from 'app/KinerjaShared/constants/path'
import { assetUrl } from 'utils/url'

export const illustration = assetUrl('/illustrations/img-pengecekan-data.png')

const CardPelaksanaan = ({
  className,
  vertical = false,
}: {
  className?: string
  vertical?: boolean
}) => {
  return (
    <Card className={clsx('flex-1', className)}>
      <section
        className={clsx('flex gap-6 p-6 h-full', {
          'flex-row items-center': !vertical,
          'flex-col': vertical,
        })}
      >
        <div className="flex-shrink-0">
          <img alt="" src={illustration} width={84} height={84} />
        </div>

        <div className="space-y-4 flex-1">
          <div className="space-y-1">
            <Text variant="heading-lg">Penilaian Kinerja</Text>
            <Text variant="body-lg" color="subdued">
              Lakukan khusus untuk satuan pendidikan yang tidak memiliki data
              Tim Kinerja.
            </Text>
          </div>
        </div>

        <div className="flex-0">
          <Link href={`${PENGELOLAAN_KINERJA_PS_PATH}/beranda`} passHref>
            <Button as="a" color="black" size="lg" className="w-52">
              Lakukan
            </Button>
          </Link>
        </div>
      </section>
    </Card>
  )
}
export default CardPelaksanaan
